import { get, writable } from 'svelte/store';
import { getTables } from '../controllers/APIController';


const tablesStore = () => {
  	
	const { subscribe, set, update } = writable([]);
	
    const methods = {
        async fetchTables(casinoId) {
            const res = await getTables(casinoId);
            console.log(casinoId + " tables: " + JSON.stringify(res));
            for (let table of res)
            {
                if (table.num_players == 5)
                    table.table_type = "blue_table";
                else
                    table.table_type = "red_table";

                if (!table.name)
                    table.name = "Table " + table.id;
            }
            set(res);
            return res;
        },

        async getTableById(casinoId, tableId) {
            let tables = get(this);
            if (!tables || !tables.length)
            tables = await this.fetchTables(casinoId);    //fetch tables if not available yet

            for (let i in tables)
                if (tables[i].id == tableId)
                    return tables[i];

            return null;
        }
    }

    return {
        subscribe,
        ...methods
    }
}

export const currentTable = writable(0);

export default tablesStore();